import {
  langsList,
  scholarSystemsList,
} from "../config/settings-langs-and-scholar-systems.mjs";

/**
 * Get most efficient lang depending on user's browser a element from the firstArray into the second Array. Return null if not found
 */
export function getBestLangForBrowser() {
  const langsBrowser = navigator.languages;
  const langsEleda = langsList;
  //console.log("getBestLangForBrowser langsBrowser:", langsBrowser, langsEleda);

  var result = langsBrowser.find((val) => langsEleda.includes(val)); //try to find with the loing version of lang
  if (!result) {
    // if no result try again but with the first short lang version (if browser is set on en, return the first en from Eleda list)
    const shortLangsBrowser = langsBrowser.map((elt) => elt.substring(0, 2));
    const shortLangsEleda = langsEleda.map((elt) => elt.substring(0, 2));
    var index = -1;
    shortLangsBrowser.find((val) => {
      console.log("findIndex:", val, shortLangsEleda.includes(val));
      index = shortLangsEleda.indexOf(val);
      if (index != -1) {
        console.log("lang found", langsEleda[index], index);
        result = langsEleda[index];
        return true;
      }
    });
  }
  if (result) {
    //console.log("getBestLangForBrowser", result);
    return result;
  } else {
    //if no result again get the US version
    return "fr-FR";
  }
}
/* Get most efficient lang depending on user's browser a element from the firstArray into the second Array. Return null if not found*/
export function getBestScholarSystemForBrowser() {
  var scholarSystemClosestToLocale = scholarSystemsList.find(
    (elt) => elt.codeLang == getBestLangForBrowser()
  );
  console.log("scholarSystemClosestToLocale", scholarSystemClosestToLocale);
  if (scholarSystemClosestToLocale) {
    return scholarSystemClosestToLocale.code;
  } else {
    return "FR";
  }
}
